import { render, staticRenderFns } from "./ParticipantAvatar.vue?vue&type=template&id=22dac246&"
import script from "./ParticipantAvatar.vue?vue&type=script&lang=js&"
export * from "./ParticipantAvatar.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantAvatar.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VIcon})
